module.exports = {"tag":"div","class":"box","children":[{"tag":"canvas","class":"roi-canvas"},{"tag":"div","class":"roi-guide"}]}